import { API } from '.';

class CandidacyService {
    async createCandidacy(data) {
        const response = await API.post('/api/candidacies', {
            data: data,
        });

        return response.data.data;
    }

    async updateCandidacy(candidacy) {
        const response = await API.put(`/api/candidacies/${candidacy.id}`, {
            data: candidacy,
        });

        return response.data.data;
    }
}

export default CandidacyService;
